var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.769531,
    y: 0.269531,
    width: 39.4609,
    height: 39.4609,
    rx: 18.3003,
    fill: "#746115",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3205 17.5232C12.4201 15.1946 14.3394 13.3374 16.6924 13.3374H24.3029C26.656 13.3374 28.5752 15.1946 28.6749 17.5232H12.3205Z",
    fill: "#9B811B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6789 18.6647V22.2797C28.6789 24.6965 26.7197 26.6557 24.3029 26.6557H16.6924C14.2756 26.6557 12.3164 24.6965 12.3164 22.2797V18.6647H28.6789ZM15.9314 22.0894C15.6161 22.0894 15.3606 22.345 15.3606 22.6602C15.3606 22.9755 15.6161 23.231 15.9314 23.231H19.7366C20.0518 23.231 20.3074 22.9755 20.3074 22.6602C20.3074 22.345 20.0518 22.0894 19.7366 22.0894H15.9314Z",
    fill: "#9B811B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.5ca0cc5dfa50129371593ee493f6e1b9.svg";
export { ForwardRef as ReactComponent };